export default __webpack_public_path__ + "static/uiux-35eb3be85d106930651471cf9f7cd39d.svg";